import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  NOTIFICATION_PREFERENCES_QUERY_KEY,
  NOTIFICATION_PREFERENCES_STALE_TIME,
} from './constants'
import { notificationPreferencesApi } from './services'

export const useNotificationPreferencesQuery = () => {
  return useQuery({
    queryKey: NOTIFICATION_PREFERENCES_QUERY_KEY(),
    queryFn: notificationPreferencesApi.getPreferences,
    staleTime: NOTIFICATION_PREFERENCES_STALE_TIME,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}

export const useUpdateNotificationPreferencesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: notificationPreferencesApi.updatePreferences,
    onSuccess: (data) => {
      queryClient.setQueryData(NOTIFICATION_PREFERENCES_QUERY_KEY(), data)
    },
  })
}
